import API from "@/config/api";
import { DEFAULT_REGISTERABLE_ROLES } from "@/lib/roles";
import type { UserRole } from "@/types/role";
import { useQuery } from "@tanstack/react-query";

export default function useRegisterbleRoles() {
  return useQuery({
    queryKey: ["registerableRoles"],
    queryFn: async () => {
      const response = await API.main.get<{
        message: string;
        roles: UserRole[];
      }>("/auth/registerable-roles");
      return response.data.roles.length > 0 ? response.data.roles : DEFAULT_REGISTERABLE_ROLES;
    },
  });
}
